export default __webpack_public_path__ + "static/media/lsd-user-cel.1776cc42.webp";